import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    cycleList: [],
    cycleListTotal: 0,
    cycleDetail: {},
    tempData: [],
    tempDataTotal: 0,
    realData: [],
    realDataTotal: 0
  },
  mutations: {
    setData(state, payload) {
      state[payload.n] = payload.d;
    }
  },
  actions: {
    getCycleList({ commit }, data) {
      api.getCycleList(data).then(({ data }) => {
        commit("setData", {
          n: "cycleList",
          d: data.list || []
        });
        commit("setData", {
          n: "cycleListTotal",
          d: data.totalCount
        });
      });
    },
    getCycleDetail({ commit }, data) {
      commit("setData", {
        n: "cycleDetail",
        d: {}
      });
      api
        .getCycleDetail({
          id: data
        })
        .then(({ data }) => {
          commit("setData", {
            n: "cycleDetail",
            d: data
          });
        });
    },
    getTempData({ commit }, data) {
      commit("setData", {
        n: "tempData",
        d: []
      });
      api.getTempData(data).then(({ data }) => {
        commit("setData", {
          n: "tempData",
          d: data.list
        });
        commit("setData", {
          n: "tempDataTotal",
          d: data.totalCount
        });
      });
    },
    addTempData({ commit }, data) {
      return new Promise(resolve => {
        api.addTempData(data).then(res => {
          resolve(res);
        });
      });
    },
    removeTempData({ commit }, data) {
      return new Promise(resolve => {
        api.removeTempData(data).then(res => {
          resolve(res);
        });
      });
    },
    getRealData({ commit }, data) {
      commit("setData", {
        n: "realData",
        d: []
      });
      api.getRealData(data).then(({ data }) => {
        commit("setData", {
          n: "realData",
          d: data.list
        });
        commit("setData", {
          n: "realDataTotal",
          d: data.totalCount
        });
      });
    },
    updateTotalRealFee({ commit }, data) {
      return new Promise(resolve => {
        api.updateTotalRealFee(data).then(res => {
          resolve(res);
        });
      });
    },
    updateStatus({ commit }, data) {
      return new Promise(resolve => {
        api.updateStatus(data).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule("contractFee", store);
